import React, { useState, useEffect } from "react";
import moment from "moment";
import {
  Box,
  Heading,
  Text,
  SimpleGrid,
  Stack,
  Flex,
  Spinner,
} from "@chakra-ui/core";
import getFormattedAmount from "../../helpers/formatAmount"
import { MdKeyboardArrowDown } from "react-icons/md";

const PayoutsGrid = ({ retrievedPayouts }) => {
  const [payouts, setPayouts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (retrievedPayouts) {
      setPayouts(retrievedPayouts);
      setLoading(false);
    }
  }, [retrievedPayouts]);



  if (loading) {
    return (
      <Flex alignItems="center" height="50vh" justifyContent="center">
        <Spinner />
      </Flex>
    );
  }

  return (
    <>
      {/** Grid header/filter */}
      {payouts.length === 0 && !loading ? (
        <Flex align="center" justify="center" marginY="1rem">
          <Text fontSize="1rem" fontWeight="bold">
            No payouts found
          </Text>
        </Flex>
      ) : (
        <>
          <SimpleGrid
            columns={4}
            spacing={0}
            color="primary.400"
            fontSize={["xs", "sm", "sm", "sm"]}
          >
            <Box p="8px" height="auto" bg="warning.100" color="primary.500">
              <Stack isInline alignItems="flex-end">
                <Heading as="h6" size="sm">
                  Date
                </Heading>
                <Box as={MdKeyboardArrowDown} />
              </Stack>
            </Box>
            <Box p="8px" height="auto" bg="warning.100" color="primary.500">
              <Stack isInline alignItems="flex-end">
                <Heading as="h6" size="sm">
                  Amount
                </Heading>
                <Box as={MdKeyboardArrowDown} />
              </Stack>
            </Box>
            <Box p="8px" height="auto" bg="warning.100" color="primary.500">
              <Heading as="h6" size="sm">
                Account
              </Heading>
            </Box>
            <Box p="8px" height="auto" bg="warning.100" color="primary.500">
              <Heading as="h6" size="sm">
                Status
              </Heading>
            </Box>
          </SimpleGrid>
          <Box
            borderLeftWidth="1px"
            borderRightWidth="1px"
            borderColor="primary.100"
          >
            {/** Grid with all data */}
            {payouts.map((payout, index) => {
              const date = moment
                .unix(parseInt(payout.created))
                .format("DD.MM.YYYY");
              return (
                <SimpleGrid
                  key={payout.amount}
                  columns={4}
                  spacing={0}
                  color="primary.400"
                  fontSize={["xs", "sm", "sm", "sm"]}
                >
                  <Box
                    bg={index % 2 !== 0 ? "#fafafa" : "none"}
                    p="12px"
                    height="auto"
                  >
                    <Text fontWeight="bold">{date}</Text>
                  </Box>
                  <Box
                    bg={index % 2 !== 0 ? "#fafafa" : "none"}
                    p="12px"
                    height="auto"
                  >
                    {getFormattedAmount(payout.amount)}
                  </Box>
                  <Box
                    bg={index % 2 !== 0 ? "#fafafa" : "none"}
                    p="12px"
                    height="auto"
                  >
                    {payout.type.charAt(0).toUpperCase() +
                      payout.type.slice(1).replace("_", " ")}
                  </Box>
                  <Box
                    bg={index % 2 !== 0 ? "#fafafa" : "none"}
                    p="12px"
                    height="auto"
                  >
                    {payout.status.charAt(0).toUpperCase() +
                      payout.status.slice(1)}
                  </Box>
                </SimpleGrid>
              );
            })}
          </Box>
        </>
      )}
    </>
  );
};

export default PayoutsGrid;
